import React from 'react';
import { Help } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { TOptions, StringMap } from 'i18next';

interface Props {
  id: string;
  message: string;
  options?: string | TOptions<StringMap>;
}

export function Tooltip({ id, message, options }: Props): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <span
        className='info-tooltip'
        data-tip
        data-for={`tooltip-${id}`}
      >
        <Help />
        <ReactTooltip id={`tooltip-${id}`} place='right' type='light' effect='solid'>
          {t(message, options)}
        </ReactTooltip>
      </span>
      <p className='tooltip-mobile'>{t(message, options)}</p>
    </>
  );
}
